import "./App.css";
import Weather from "./Weather";
import FooterLinks from "./FooterLinks";

function App() {
  return (
    <div className="App">
      <Weather />
      <FooterLinks />
    </div>
  );
}

export default App;
